export const environment = {
    envName: "production",
    version: "1.0.0",
    production: true,
    apiUrl: 'https://api.prestigesalgados.com.br', // A URL do NestJS
    googleClientId: '427749940086-vdlja22cpm38ah6i0gkfcnkfi1akq7vt.apps.googleusercontent.com'
};
